export enum HEADER {
  'UPDATE_HEADER' = '[HEADER] UPDATE_HEADER_TITLE',
  'UPDATE_HEADER_ICON' = '[HEADER] UPDATE_HEADER_ICON'
}